<template>
  <div id="app">
    <b-container>
      <b-navbar id="mainnav" toggleable="lg">
        <b-navbar-brand href="/#/">
          <img src="/dist/logo.png" alt="logo" width="112" height="28">
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item href="/#/">{{$lang('home')}}</b-nav-item>
            <!-- <b-nav-item href="#">{{$lang('help')}}</b-nav-item> -->
            <!-- <b-nav-item href="#">{{$lang('about')}}</b-nav-item> -->
            <b-nav-item-dropdown right>
              <template slot="button-content"><i class="fa fa-globe mr-2" aria-hidden="true"></i>{{$lang('currentLang')}}</template> 
              <b-dropdown-item @click="changeLang('en')">English</b-dropdown-item>
              <b-dropdown-item @click="changeLang('de')">Deutsch</b-dropdown-item>
              <b-dropdown-item @click="changeLang('pl')">Polski</b-dropdown-item>              
              <b-dropdown-item @click="changeLang('ru')">Русский</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown v-if="userInfo.loggedIn===1" class="text-capitalize" right>
              <template slot="button-content"><i class="fa fa-user mr-2" aria-hidden="true"></i>{{userInfo.userName}}</template> 
              <b-dropdown-item @click="logout()">{{$lang('logout')}}</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </b-container>
    <router-view></router-view>
    <div v-if="!cookieOK" class="bottom__cookie-block d-flex align-items-center justify-content-center">
      <p class="mb-1">{{$lang('cookieWarn')}}</p>
      <b-button class="mx-2" @click.prevent="setCookieOK()">ОK</b-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex';
export default {
  created() {
     this.$store.dispatch('updateUserInfo')
  }, 
  computed: mapState(['userInfo', 'cookieOK']),
  methods: {
    logout() {
      this.$store.dispatch('logout')
    },
    changeLang(newlang)  {
      this.$store.dispatch('changeLang',newlang)
    },
    setCookieOK() {
      this.$store.dispatch('setCookieOK')
    } 
  },
  locales: {
      en: {
          home: "Home",
          help: "Help",
          about: "About",
          logout: "Logout",
          currentLang: 'English',
          cookieWarn: 'This site uses cookies. By continuing to use the site, you agree to the collection of cookies.'
      },
      de: {
          home: "Startseite",
          help: "Hilfe",
          about: "Über",
          logout: "Ausloggen",
          currentLang: 'Deutsch',
          cookieWarn: 'Diese Seite verwendet Cookies. Durch die weitere Nutzung der Website stimmen Sie der Sammlung von Cookies zu.'
          },
      ru: {
          home: "На главную",
          help: "Помощь",
          about: "О программе",
          logout: "Выход",
          currentLang: 'Русский',
          cookieWarn: 'Этот сайт использует cookie. Продолжая использовать сайт, вы соглашаетесь на сбор файлов cookie.'
          },
      pl: {
          home: "Strona główna",
          help: "Pomoc",
          about: "O aplikacji",
          logout: "Wyjście",
          currentLang: 'Polski',
          cookieWarn: 'Ta strona korzysta z plików cookies. Kontynuując korzystanie ze strony, wyrażasz zgodę na gromadzenie plików cookie.'
          },
    }
}
</script>
<style>
#mainnav {
  min-height: 75px;
}
section {
  padding-top: 2rem;
  padding-bottom: 1rem;
}
.statemark::before {
  display: inline-block;
  border: 0.15em solid;
  border-radius: 50%;  
  border-color: inherit;
  height: 14px;
  width: 14px;
  float: left;
  margin-right: 5px;
  line-height: inherit;
  margin-top: 6px;  
  content: " ";
}
.bottom__cookie-block {
    width: 100%;
    left: 0;
    padding: 16px 0;
    color: #fff;
    background-color: #4b505a;
    display: none;
    position: fixed;
    bottom: 0;
    z-index: 100000;
    text-align: center;
    overflow-y: auto;
    -webkit-transform: translateZ(0);
}
</style>



// WEBPACK FOOTER //
// src/App.vue